import React from "react";
import s from "./index.module.scss";
import { CSSTransition } from "react-transition-group";
// import classNames from "classnames/bind";
// const cx = classNames.bind(s);

const Loading = ({ show, hide }) => (
	<CSSTransition in={hide} timeout={200} classNames={{ ...s }} unmountOnExit>
		<div className={s.loading}>
			<h1 style={{ opacity: show && 1 }} className={s.year}>
				2019
			</h1>
		</div>
	</CSSTransition>
);

export default Loading;
